/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Createdbyuserid3Inputs */

const en_entity_createdbyuserid3 = /** @type {(inputs: Entity_Createdbyuserid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created By User ID`)
};

const de_entity_createdbyuserid3 = /** @type {(inputs: Entity_Createdbyuserid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt von Benutzer-ID`)
};

/**
* | output |
* | --- |
* | "Created By User ID" |
*
* @param {Entity_Createdbyuserid3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_createdbyuserid3 = /** @type {((inputs?: Entity_Createdbyuserid3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Createdbyuserid3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_createdbyuserid3(inputs)
	return de_entity_createdbyuserid3(inputs)
});
export { entity_createdbyuserid3 as "entity_createdByUserId" }